module.exports = __webpack_public_path__ + "img/surpresa.5e5ae5b0.png";